import React, {useEffect, useState, useRef, useContext} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './MobileMenu.module.css';
import logo_svg from "../static_files/kiraAi logo.svg";
import {SwapMainAppContext} from '../../SwapMainAppContext';
import axios from 'axios';
import moreImg from '../static_files/more-horizontal.svg';
import PortalDropdown from '../../components/PortalDropdown';

import inviteImg from '../static_files/Invite-friends.svg';
import inviteImgGreen from '../static_files/Invite-friends green.svg';
import transactionImg from '../static_files/Transactions.svg';
import transactionImgGreen from '../static_files/Transactions green.svg';
import myAssetsImg from '../static_files/My Assets.svg';
import myAssetsImgGreen from '../static_files/My Assets Green.svg';

import c2cImg from '../static_files/C2C Network.svg';
import accountImg from '../static_files/Account_leftPanel.svg';
import kiraAiImg from '../static_files/chat.svg';
import chatImg from '../static_files/kra_icon_mobile.png'
import renameImg from "../static_files/edit-03.png";
import deleteImg from "../static_files/delete-2.png";

const BACKEND_URL = 'https://kira-ai-256611876551.europe-west1.run.app/';

function SideMenu({isOpen, onOverlayClick, stopPropagation}) {
    const location = useLocation();
    const navigate = useNavigate();
    const [isRendered, setIsRendered] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const imagesRef = useRef({});
// 添加 Context 和状态用于 Recent Chats
    const {
        conversations,
        setConversations,
        currentConversationId,
        setCurrentConversationId
    } = useContext(SwapMainAppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const moreBtnRefs = useRef({});
    const [editingChatId, setEditingChatId] = useState(null);
    const [editingTitle, setEditingTitle] = useState('');
    const [walletAddress, setWalletAddress] = useState(null);

    // 获取钱包地址
    useEffect(() => {
        const storedWalletAddress = localStorage.getItem('walletAddress');
        if (storedWalletAddress) {
            setWalletAddress(storedWalletAddress);
        }
    }, []);

    // 添加 fetchConversationTitles 函数来获取对话
    useEffect(() => {
        const fetchConversationTitles = async () => {
            if (!walletAddress) {
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);

                const response = await axios.get(`${BACKEND_URL}/api/conversations/titles`, {
                    params: {wallet_address: walletAddress}
                });
                const titledConversations = response.data.conversations.map(conv => ({
                    id: conv.id,
                    title: conv.title,
                    timestamp: conv.timestamp,
                    lastMessage: null
                }));

                setConversations(titledConversations);
            } catch (error) {
                console.error('Error fetching conversation titles:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchConversationTitles();
    }, [walletAddress, setConversations]);

    // 添加 dropdown 监听
    useEffect(() => {
        const handleClick = () => setOpenDropdownId(null);
        if (openDropdownId !== null) {
            document.addEventListener('click', handleClick);
        }
        return () => document.removeEventListener('click', handleClick);
    }, [openDropdownId]);

    // 处理选择对话的函数
    const handleSelectConversation = (id) => {
        setCurrentConversationId(id);
        // 跳转到 KiraAI 页面
        const selectedConv = conversations.find(conv => conv.id === id);
        if (selectedConv) {
            navigate('/kira-ai', {state: {messages: selectedConv.messages}});
            onOverlayClick(); // 关闭菜单
        }
    };


    // 预加载图像
    useEffect(() => {
        const preloadImages = () => {
            const images = [
                inviteImg, inviteImgGreen, transactionImg, transactionImgGreen,
                myAssetsImg, myAssetsImgGreen, c2cImg, accountImg, kiraAiImg
            ];

            let loadedCount = 0;
            const totalImages = images.length;

            images.forEach(src => {
                if (imagesRef.current[src]) {
                    // 已经加载过的图像直接计数
                    loadedCount++;
                    if (loadedCount === totalImages) {
                        setImagesLoaded(true);
                    }
                } else {
                    const img = new Image();
                    img.onload = () => {
                        loadedCount++;
                        imagesRef.current[src] = true;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.onerror = () => {
                        loadedCount++;
                        if (loadedCount === totalImages) {
                            setImagesLoaded(true);
                        }
                    };
                    img.src = src;
                }
            });
        };

        // 立即开始预加载，无论菜单是否打开
        preloadImages();
    }, []);

    // 确保即使菜单关闭时也渲染DOM，以便可以预加载内容
    useEffect(() => {
        if (isOpen) {
            setIsRendered(true);
        }
    }, [isOpen]);

    // 当菜单关闭后延迟移除DOM
    useEffect(() => {
        if (!isOpen && isRendered) {
            const timer = setTimeout(() => {
                setIsRendered(false);
            }, 500); // 延长一点以确保动画完成

            return () => clearTimeout(timer);
        }
    }, [isOpen, isRendered]);

    // Same logic as in LeftPanel for My Assets
    const handleMyAssetsClick = () => {
        const token = localStorage.getItem('gatewayToken');
        if (token) {
            navigate(`/swap?token=${token}`);
        } else {
            navigate('/');
        }
    };

    const handleTransactionsClick = () => {
        navigate('/transaction');
    };

    const handlekiraAiClick = () => {
        navigate('/kira-ai');
    };

    const handleInviteClick = () => {
        navigate('/invite');
        onOverlayClick();
    };

    const handleAccountClick = () => {
        navigate('/account');
    };

    const handleC2CClick = () => {
        navigate('/c2c');
    };

    const isMyAssetsActive =
        location.pathname === '/' || location.pathname.startsWith('/swap');

    // 菜单未打开时不渲染任何内容
    if (!isOpen && !isRendered) {
        return null;
    }

    // 准备菜单渲染类
    const menuContainerClass = `${styles.sideMenuContainer} ${isOpen ? styles.open : ''} ${imagesLoaded ? styles.imagesLoaded : ''}`;

    return (
        <>
            <div
                className={menuContainerClass}
                onClick={stopPropagation}
            >
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '32px',
                    width: '100%',
                    marginBottom: '32px'
                }}>
                    <img
                        src={logo_svg}
                        style={{height: '34px', marginLeft: "8px"}}
                        alt="KiraAI"
                    />
                    <button className={styles.closeButton} onClick={onOverlayClick}>
                        ✕
                    </button>
                </div>
                <div>
                    {/* My Assets */}
                    <div
                        className={`${styles.menuItem} ${
                            isMyAssetsActive ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleMyAssetsClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={isMyAssetsActive ? myAssetsImgGreen : myAssetsImg}
                                alt="My Assets"
                            />
                        </div>
                        <span>My Assets</span>
                    </div>

                    {/* Transactions */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/transaction' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleTransactionsClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={
                                    location.pathname === '/transaction'
                                        ? transactionImgGreen
                                        : transactionImg
                                }
                                alt="Transactions"
                            />
                        </div>
                        <span>Transactions</span>
                    </div>

                    {/* C2C Network */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/c2c' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleC2CClick}
                    >
                        <div className={styles.imageContainer}>
                            <img src={c2cImg} alt="C2C Network" style={{paddingRight: '9px'}}/>
                        </div>
                        <span>C2C Network</span>
                    </div>

                    {/* Invite Friends */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/invite' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleInviteClick}
                    >
                        <div className={styles.imageContainer}>
                            <img
                                src={
                                    location.pathname === '/invite' ? inviteImgGreen : inviteImg
                                }
                                style={{paddingRight: '9px'}}
                                alt="Invite Friends"
                            />
                        </div>
                        <span>Invite Friends</span>
                    </div>

                    {/* Kira - AI */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/kira-ai' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handlekiraAiClick}
                    >
                        <img
                            style={{
                                marginLeft: '18px',
                                marginRight: '10px',
                                width: '32px',
                                height: '32px',
                                padding: '0',
                                borderRadius: '50%'
                            }}
                            src={chatImg}
                            alt="Kira AI icon"
                        />
                        <span>Kira Chat</span>
                    </div>

                    {/* Account */}
                    <div
                        className={`${styles.menuItem} ${
                            location.pathname === '/account' ? styles.selected : ''
                        } ${imagesLoaded ? styles.imageLoaded : ''}`}
                        onClick={handleAccountClick}
                    >
                        <div className={styles.imageContainer}>
                            <img src={accountImg} style={{paddingRight: '9px'}} alt="Account"/>
                        </div>
                        <span>Account</span>
                    </div>
                    <div
                        style={{
                            width: '100%',
                            height: '1px',
                            backgroundColor: '#343434',
                            // marginInline: '13px',
                            marginTop: '20px',
                            marginBottom: '28px'
                        }}
                    />
                    {/* Recent Chats Section - 新增部分 */}
                    {conversations.length > 0 && (
                        <div className={styles.recentChatsSection}>
                            <h3 className={styles.recentChatsTitle}>Recent chats</h3>
                            <div className={styles.chatScrollArea}>
                                {isLoading ? (
                                    <div className={styles.loadingContainer}>
                                        <div className={styles.loadingSpinner}></div>
                                    </div>
                                ) : (
                                    <ul className={styles.chatList}>
                                        {conversations.map((conv) => {
                                            if (!moreBtnRefs.current[conv.id]) {
                                                moreBtnRefs.current[conv.id] = React.createRef();
                                            }
                                            return (
                                                <li
                                                    key={conv.id}
                                                    className={`${styles.chatItem} ${conv.id === currentConversationId ? styles.activeChat : ''}`}
                                                    onClick={() => handleSelectConversation(conv.id)}
                                                    style={{position: 'relative'}}
                                                >
                                                    <div style={{display: 'flex', alignItems: 'center', width: '100%'}}>
                                                        <span className={styles.chatItemContent}>
                                                            {conv.title
                                                                ? (conv.title.length > 25 ? conv.title.slice(0, 25) + '...' : conv.title)
                                                                : conv.lastMessage
                                                                    ? (conv.lastMessage.length > 25 ? conv.lastMessage.slice(0, 25) + '...' : conv.lastMessage)
                                                                    : 'New Conversation'}
                                                        </span>

                                                    </div>
                                                    {/*<img*/}
                                                    {/*    ref={moreBtnRefs.current[conv.id]}*/}
                                                    {/*    className={`${styles.moreOptions} ${conv.id === currentConversationId ? styles.activeMoreOptions : ''}`}*/}
                                                    {/*    onClick={e => {*/}
                                                    {/*        e.stopPropagation();*/}
                                                    {/*        setOpenDropdownId(openDropdownId === conv.id ? null : conv.id);*/}
                                                    {/*    }}*/}
                                                    {/*    src={moreImg}*/}
                                                    {/*/>*/}
                                                    {/*{openDropdownId === conv.id && (*/}
                                                    {/*    <PortalDropdown*/}
                                                    {/*        anchorRef={moreBtnRefs.current[conv.id]}*/}
                                                    {/*        onClose={() => setOpenDropdownId(null)}*/}
                                                    {/*    >*/}
                                                    {/*        <div className={styles.dropdownMenu}>*/}
                                                    {/*            <div*/}
                                                    {/*                className={styles.dropdownItem}*/}
                                                    {/*                onClick={e => {*/}
                                                    {/*                    e.stopPropagation();*/}
                                                    {/*                    setOpenDropdownId(null);*/}
                                                    {/*                    setEditingChatId(conv.id);*/}
                                                    {/*                    setEditingTitle(conv.title || '');*/}
                                                    {/*                }}*/}
                                                    {/*            >*/}
                                                    {/*                <img className={styles.renameIcon} src={renameImg}*/}
                                                    {/*                     alt="Rename"/>*/}
                                                    {/*                Rename*/}
                                                    {/*            </div>*/}
                                                    {/*            <div*/}
                                                    {/*                className={styles.dropdownItem}*/}
                                                    {/*                onClick={e => {*/}
                                                    {/*                    e.stopPropagation();*/}
                                                    {/*                    setOpenDropdownId(null);*/}
                                                    {/*                    setChatToDelete(conv.id);*/}
                                                    {/*                    setShowDeleteModal(true);*/}
                                                    {/*                }}*/}
                                                    {/*            >*/}
                                                    {/*                <img className={styles.deleteIcon} src={deleteImg}*/}
                                                    {/*                     alt="Delete"/>*/}
                                                    {/*                Delete*/}
                                                    {/*            </div>*/}
                                                    {/*        </div>*/}
                                                    {/*    </PortalDropdown>*/}
                                                    {/*)}*/}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default SideMenu;